import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const addonCategoryService = {
    async getDropdownAsync()
    {
         const response=await apiClient.get(endPoints.addOnCategory.dropdown);
         return response.data
       
    }
}